import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SnackBar } from './snackbar/snackbar.service';
import { reducer } from './reducers';
import { NotificationEffects } from './effects/notification.effects';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { ExtendedPositionBuilder } from './snackbar/snackbar-position-strategy';
import * as i0 from "@angular/core";
/**
 * Notification Module
 *
 * @export
 * @class NotificationsModule
 */
export class NotificationsModule {
    static { this.ɵfac = function NotificationsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NotificationsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [SnackBar, { provide: OverlayPositionBuilder, useClass: ExtendedPositionBuilder }], imports: [CommonModule,
            MatLegacySnackBarModule,
            StoreModule.forFeature('notification', reducer),
            EffectsModule.forFeature([NotificationEffects])] }); }
}
//# sourceMappingURL=notifications.module.js.map